<section class="d-flex h-100 flex-column overflow-hidden">
  <h3 class="my-4">Lista degli enti</h3>

  <div class="d-flex overflow-hidden h-100">
  @if (listEnti.length > 0) {
  <it-table class="overflow-auto w-100" itSort (sortChange)="sortData($event)">
    <ng-container thead>
      <tr>
        <th it-sort-header="ragioneSociale" scope="col">Ragione sociale</th>
        <th it-sort-header="codiceFiscale" scope="col">Codice fiscale</th>
        <th it-sort-header="codiceAusa" scope="col">Codice Ausa</th>
        <th scope="col">Dettaglio</th>
      </tr>
    </ng-container>

    <ng-container tbody>
      @for (element of listEnti; track $index) {
      <tr>
        <td [title]="element.ragioneSociale">{{element.ragioneSociale}}</td>
        <td [title]="element.codiceFiscale">{{element.codiceFiscale}}</td>
        <td [title]="element.codiceAusa">{{element.codiceAusa}}</td>
        <td title="Seleziona">
          <a onclick="return false" href="/" (click)="confirmModal.toggle()">
            <it-icon name="search" color="primary" size="sm"></it-icon>
          </a>
          <it-modal #confirmModal="itModal" closeButton="false">
            <ng-container modalTitle>Conferma selezione ente</ng-container>
            <ng-container description>
              <p>Sei sicuro di voler selezionare l'ente <strong>{{element.ragioneSociale}}</strong>?</p>
            </ng-container>
            <ng-container footer>
              <button itButton="outline-primary" size="sm" type="button" data-bs-dismiss="modal">Annulla</button>
              <button itButton="primary" size="sm" type="button" (click)="goToEnte(element.idEnte)" data-bs-dismiss="modal">Conferma</button>
            </ng-container>
          </it-modal>
        </td>
      </tr>
      }
    </ng-container>
  </it-table>
  } @else {
  <h5 class="text-center">Nessun ente censito</h5>
  }
</div>
<it-pagination
  *ngIf="totalPages > 0"
  alignment="center"
  [currentPage]="currentPage"
  [pageNumbers]="totalPages"
  [currentChanger]="pageOffset"
  (changerEvent)="changerEvent($event)"
  (pageEvent)="getPage($event)">
</it-pagination>
</section>

